export default __webpack_public_path__ + "static/media/flag-belarus.b8a7091c.svg";